import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {trigger} from '@angular/animations';
import {smoothEnterLeaveAnimation} from '../../../shared/animations/custom-animations';
import {ForgotUsernameService} from '../../services/forgot-username.service';
import {VALID_EMAIL_ADDRESS_FORMAT_VALIDATION_ERROR_CODE, ValidationErrorResponse} from '../../../shared/models/validation-error-response';
import {PHONE_NUMBER_LIST} from 'src/main/resources/static/angular2/app/shared/constants/phone-numbers.const';
import {DomainNameParserService} from 'src/main/resources/static/angular2/app/shared/services/domain-name-parser.service';

@Component({
  selector: 'app-forgot-username',
  templateUrl: './forgot-username.component.html',
  styleUrls: [
    './forgot-username.component.css',
    './../../../../assets/css/floating-labels.css'
  ],
  animations: [
    trigger('showUsernameEmailResentMessage', smoothEnterLeaveAnimation('100ms', '100ms')),
    trigger('showUsernameEmailSentAlert', smoothEnterLeaveAnimation('100ms', '100ms')),
    trigger('showResendEmailButton', smoothEnterLeaveAnimation('100ms', '100ms')),
    trigger('showGenericErrorAlert', smoothEnterLeaveAnimation('100ms', '100ms'))
  ]
})
export class ForgotUsernameComponent implements OnInit {

  sendUsernameViaEmailButtonClicked = false;
  usernameByEmailRequestSent = false;
  usernameByEmailResentButtonClicked = false;
  genericErrorAlertShown = false;
  customerServicePhone: string;

  forgotUsernameForm = new FormGroup({
    emailInput: new FormControl('', [
      Validators.required,
      Validators.email
    ])
  });

  constructor(private forgotUsernameService: ForgotUsernameService,
              private domainNameParserService: DomainNameParserService) {
    this.customerServicePhone = PHONE_NUMBER_LIST[this.domainNameParserService.getState()];
  }

  ngOnInit(): void {
  }

  sendUsernameViaEmail(): void {
    this.sendUsernameViaEmailButtonClicked = true;
    if (!this.forgotUsernameForm.valid) {
      return;
    }
    this.forgotUsernameService.remindUsernameByEmail(this.forgotUsernameForm.controls.emailInput.value)
      .subscribe(validationErrorResponse => {
        if (validationErrorResponse === null) {
          this.usernameByEmailRequestSent = true;
          this.genericErrorAlertShown = false;
        } else {
          if (this.containsEmailValidationError(validationErrorResponse)) {
            // means invalid email
            // workaround for the backend 400 response, in case of missing dot in the domain name
            this.forgotUsernameForm.controls.emailInput.setErrors({email: true});
            this.usernameByEmailRequestSent = false;
          } else {
            console.error('ServiceLayer registration endpoint returned validation error. ' +
              'Details: ' + JSON.stringify(validationErrorResponse));
            this.showGenericErrorMessage();
          }
        }
      }, error => {
        console.error('ServiceLayer returned error. Details: ' + JSON.stringify(error));
        this.showGenericErrorMessage();
      });
  }

  private showGenericErrorMessage(): void {
    this.genericErrorAlertShown = true;
    this.usernameByEmailRequestSent = false;
  }

  containsEmailValidationError(validationResponse: ValidationErrorResponse): boolean {
    for (const validationError of validationResponse?.errors) {
      if (validationError.code === VALID_EMAIL_ADDRESS_FORMAT_VALIDATION_ERROR_CODE) {
        return true;
      }
    }
    return false;
  }

  resendUsernameEmail(): void {
    this.sendUsernameViaEmail();
    this.usernameByEmailResentButtonClicked = true;
  }
}
